const taffelTemplates =
{
	angularModule1: `'use strict';

// *********************************
//	MUST BE BUILT IN TAFFEL
// *********************************

// ---------------------------------
//  Imports
// ---------------------------------

var angular = require('angular');
var ngSanitize = require('angular-sanitize');
var uiRouter = require('angular-ui-router');

var Agile = require("../02 Source/agilejs/Agile");
var AgileDisplayObject = require("../02 Source/agilejs/display/AgileDisplayObject");
var AgileString = require("../02 Source/agilejs/utils/AgileString");

var IP = require("../02 Source/ip/shared/IP");
var IPGlobal = require('../02 Source/ip/IPGlobal');
var IPLayout = require('../02 Source/ip/IPLayout');
var IPPages = require('../02 Source/ip/IPPages');
var IPNavigate = require("../02 Source/ip/shared/IPNavigate");


// ---------------------------------
//  Main angular module
// ---------------------------------

IPGlobal.main = angular.module('app', [uiRouter.default, ngSanitize]);
IPGlobal.offlineMode = IPGlobalOfflineMode; // Gulp assigns false or true to that undeclared variable.

if (!(window.isLocalHost || window.isLocalPort) && !IPGlobal.offlineMode) {
	IPGlobal.trackGoogleAnalytics = true;
}

angular.module('app')
	.filter('to_trusted',
	[
		'$sce', function($sce)
		{
			return function(text)
			{
				Agile.debug("someting");
				return $sce.trustAsHtml(text);
			};
		}
	])
	
	
;


IPGlobal.main.directive('agileMouseOrTouchStart', function ($parse)//app.directive("myMethod",function($parse) {
{
	var directiveDefinitionObject =
	{
		restrict: 'A',
		scope:
		{
			method:'&agileMouseOrTouchStart',
			id: '=agileId'
		},
		link: function(scope,element,attrs)
		{
			var expressionHandler = scope.method();
			expressionHandler(scope.id, element[0]);
		}
	};
	return directiveDefinitionObject;
});



// ------------------------------------------------------------------
//
//                ********* Site structure *********
//
// ------------------------------------------------------------------


var taffelContentList = new Array();

`,














	angularModule2: `

// Root object is created first, before we after loop through all the rest of the children

IP.siteTree = new Object();
IP.siteTree.children = new Array();
IP.siteTree.provided = taffelContent0;
IP.siteTree.identPath = taffelContent0.name;
IP.siteTree.id = taffelContent0.id;
IP.siteTree.url = taffelContent0.url;
IP.siteTree.fullUrl = taffelContent0.url;
IP.siteTree.title = taffelContent0.title;
IP.siteTree.controllers = new Array();

// Make type of views easy accessible
IP.siteTree.types = new Array();

for (var views in IP.siteTree.provided.views)
{
	if (views != "") // Ignore the root.html view
	{
		IP.siteTree.types.push(AgileString.replace(IP.siteTree.provided.views[views].controller, "Controller", "")); // Remove "Controller from name
	}
}


IP.siteList = new Array();
IP.siteList.push(IP.siteTree);


for (var i = 1; i < taffelContentList.length; i++)
{
	var o = new Object();
	o.children = new Array();
	o.provided = taffelContentList[i];
	o.identPath = taffelContentList[i].name;
	o.id = taffelContentList[i].id;
	o.url = taffelContentList[i].url;
	o.title = taffelContentList[i].title;
	//o.isTransitioningOut = false;
	
	o.controllers = new Array();
	
	o.data = new Object();
	
	// Make type of views easy accessible
	o.types = new Array();
	
	for (var views in o.provided.views)
	{
		if (views != "") // Ignore if a view have no name
		{
			o.types.push(AgileString.replace(o.provided.views[views].controller, "Controller", "")); // Remove "Controller from name
		}
	}
	
	
	
	for (var prop in taffelContentList[i])
	{
		if (prop != "name" && prop != "url" && prop != "parent" && prop != "parentId" && prop != "id" && prop != "title" && prop != "resolve" && prop != "views")
		{
			var propValue = taffelContentList[i][prop];
			
			// Convert true/false strings to Booleans
			if (propValue == "true") propValue = true;
			if (propValue == "false") propValue = false;
			
			o.data[prop] = propValue;
		}
	}
	
	for (var j = 0; j < IP.siteList.length; j++)
	{
		if (taffelContentList[i].parentId == IP.siteList[j].id)
		{
			o.parent = IP.siteList[j];
			o.parentId = IP.siteList[j].id;
			
			o.fullUrl = o.parent.fullUrl+o.url;
			
			IP.siteList[j].children.push(o);
		}
	}
	
	IP.siteList.push(o);
}


function appendLevelsRecursive(treeObj, depthLevel)
{
	treeObj.depth = depthLevel;
	
	for (var i = 0; i < treeObj.children.length; i++)
	{
		appendLevelsRecursive(treeObj.children[i], depthLevel+1);
	}
}

appendLevelsRecursive(IP.siteTree, 0);



// ------------------------------------------------------------------
//
//		MAIN MODULE
//
// ------------------------------------------------------------------


IPGlobal.main.config(function($stateProvider, $urlRouterProvider)
{
	// For any unmatched url, redirect to frontpage
	$urlRouterProvider.otherwise("/");
	
	
	// ---------------------------------
	//  State provider, our "site.xml"
	// ---------------------------------
	
	$stateProvider`,







        angularModule3: `
});



IPGlobal.main.config(['$locationProvider', "$sceProvider", function($location, $sceProvider)
{
	// Disable security checking of loading. Required for loading vimeo iframes
	$sceProvider.enabled(false);
}]);

IPGlobal.main.run(['$rootScope', '$http', '$browser', '$timeout', function ($scope, $http, $browser, $timeout) {}]);



// ----------------------------------------------
//  Require the pages in the site definition
// ----------------------------------------------

require("../02 Source/ip/shared/index.controller");
require("../02 Source/ip/shared/page.base.controller");
require("../02 Source/pages/background/background");
require("../02 Source/pages/foreground/foreground");

`,

};



export default taffelTemplates;